import React from 'react';

const BackIcon = ({ width = 52, height = 52, color = "#FE531F" }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fillRule="evenodd" clipRule="evenodd" d="M37.1591 24.5345H19.9932L26.6576 17.8701C27.2635 17.2642 27.2635 16.2545 26.6576 15.6486C26.0518 15.0428 25.042 15.0428 24.4362 15.6486L15.3483 24.7365C14.9444 25.1404 14.9444 25.7462 14.9444 26.1501C14.9444 26.554 14.9444 27.1599 15.3483 27.5638L24.4362 36.6516C25.042 37.2575 26.0518 37.2575 26.6576 36.6516C27.2635 36.0458 27.2635 35.036 26.6576 34.4302L19.9932 27.7657H37.1591C37.9669 27.7657 38.7748 26.9579 38.7748 26.1501C38.7748 25.3423 37.9669 24.5345 37.1591 24.5345ZM25.8498 0.300293C11.5113 0.300293 0 11.8115 0 26.1501C0 40.4887 11.5113 52 25.8498 52C40.1884 52 51.6997 40.4887 51.6997 26.1501C51.6997 11.8115 40.1884 0.300293 25.8498 0.300293ZM25.8498 48.7687C13.3288 48.7687 3.23123 38.6711 3.23123 26.1501C3.23123 13.6291 13.3288 3.53152 25.8498 3.53152C38.3709 3.53152 48.4684 13.6291 48.4684 26.1501C48.4684 38.6711 38.3709 48.7687 25.8498 48.7687Z" fill={color} />
        </svg>



    );
};

export default BackIcon;